import { z } from 'zod';

export const baseIssueSchema = z.object({
  title: z
    .string()
    .min(1, 'Required')
    .max(50, 'Must be at most 50 characters long.'),
  content: z.string({ invalid_type_error: 'Required' }).min(1, 'Required'),
});

export const clientIssueSchema = baseIssueSchema.extend({
  implantedOn: z.date(),
  accountId: z.string(),
  embryosPerFertilization: z
    .number({ invalid_type_error: 'Required' })
    .nullable(),
});

export type ClientIssueValues = z.TypeOf<typeof clientIssueSchema>;
export type ReportRequestValues = z.TypeOf<typeof baseIssueSchema>;
